import styled from 'styled-components/macro';
import { ELEMENTS } from '../Auth/core';
import { deviceMax, deviceMin } from '../../utils/styles/breakpoints';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const StyledModal = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow}
  height: 100%;

  .StyledModalWrapper {
    background: ${COLORS.white};
    border-radius: 12px;
    width: 100%;

    @media ${deviceMin.mobileS} {
      padding: 20px 18px;
      height: 80vh;
      margin: 0 15px;
    }

    @media (min-width: 420px) {
      padding: 20px 24px;
      height: 80vh;
      margin: 0 25px;
    }

    @media ${deviceMin.tablet} {
      padding: 30px 24px;
      max-width: 545px;
      height: 326px;
      margin: 0;
    }

    @media ${deviceMin.laptopL} {
      padding: 30px 24px;
      max-width: 623px;
      height: 304px;
    }

    @media ${deviceMin.desktop} {
      max-width: 960px;
      height: 410px;
      padding: 36px 58px;
    }
  }

  .StyledModalHeader {
    ${FLEX_CONTAINER.FlexCenterRow}
    width: 100%;

    p {
      color: ${COLORS.mainColor};
      ${FONT_FAMILY.FontSemiBold}


      @media ${deviceMin.mobileS} {
        ${FONTS.font14}
      }

      @media (min-width: 420px) {
        ${FONTS.font16}
      }

      @media ${deviceMin.tablet} {
        ${FONTS.font16}
      }

      @media ${deviceMin.laptopL} {
        ${FONTS.font16}
      }
    }
  }

  .StyledModalBody {
    width: 100%;
    height: 90%;
    overflow: auto;
    padding-right: 10px;

    @media ${deviceMin.mobileS} {
      margin-top: 20px;
    }

    @media ${deviceMin.tablet} {
      margin-top: 20px;
    }

    @media ${deviceMin.laptopL} {
      margin-top: 30px;
    }

    @media ${deviceMin.desktop} {
      margin-top: 35px;
    }
  }
`;

export const QuestionsContainer = styled.div`
  ${FLEX_CONTAINER.FlexColumn}  
  z-index: 1;
  border-radius: 16px;
  background: transparent;

  @media ${deviceMin.mobileS} {
    width: 100%;
    height: 90vh;
    padding: 25px 27px;
    margin-top: 20px;
  }

  @media (min-width: 420px) {
    width: 100%;
    height: 90vh;
    padding: 26px 37px;
    margin-top: 70px;
  }

  @media ${deviceMin.tablet} {
    width: 100%;
    height: 90vh;
    padding: 43px;
    margin-top: 60px;
  }

  @media ${deviceMin.laptopL} {
    width: 100%;
    padding: 30px 70px;
    margin-top: 90px;
  }

  @media ${deviceMin.desktop} {
    width: 100%;
    height: 80vh;
    padding: 30px 120px;
    margin-top: 120px;
  }
`;

export const Container = styled(ELEMENTS.MainAuthContainer)`
  ${FLEX_CONTAINER.FlexColumn}
  padding: 0;

  ::before {
    background: rgba(164, 200, 229, 0.5);
  }

  @media ${deviceMax.laptopM} {
    p {
      ${FONTS.font16}
    }
  }

  @media ${deviceMax.mobileS} {
    p {
      ${FONTS.font14}
    }
  }
`;

export const HistoryWrapper = styled.div`
  ${FLEX_CONTAINER.FlexColumn}
  height: auto;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 10px;

  @media ${deviceMin.mobileS} {
    margin-top: 20px;
    width: 100%;
  }

  @media (min-width: 420px) {
    margin-top: 20px;
  }

  @media ${deviceMin.tablet} {
    margin-top: 10px;
  }

  @media ${deviceMin.laptopL} {
    margin-top: 0;
    width: 662px;
  }

  @media ${deviceMin.desktop} {
    margin-top: 0;
    width: 992px;
  }
`;

export const ModalQuestionWrapper = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  width: 90%;

  @media ${deviceMin.mobileS} {
    flex-direction: column;
    margin-bottom: 16px;
  }

  @media ${deviceMin.tablet} {
    flex-direction: row;
    margin-bottom: 25px;
  }

  @media ${deviceMin.laptopL} {
    flex-direction: row;
    margin-bottom: 20px;
    max-width: 662px;
  }

  @media ${deviceMin.desktop} {
    flex-direction: row;
    margin-bottom: 35px;
    max-width: 992px;
  }
`;

export const QuestionWrapper = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  height: auto;
  background: ${COLORS.white};
  border-radius: 12px;
  width: 100%;

  @media ${deviceMin.mobileS} {
    flex-direction: column;
    padding: 15px 16px;
    margin-bottom: 16px;
  }

  @media ${deviceMin.tablet} {
    flex-direction: row;
    padding: 16px 18px;
    margin-bottom: 25px;
  }

  @media ${deviceMin.laptopL} {
    flex-direction: row;
    padding: 16px 22px;
    max-width: 662px;
    margin-bottom: 20px;
  }

  @media ${deviceMin.desktop} {
    flex-direction: row;
    padding: 16px 22px;
    max-width: 992px;
    margin-bottom: 35px;
  }
`;

export const ItemWrapper = styled.div`
  ${FLEX_CONTAINER.FlexRow}

  p {
    color: ${COLORS.black};

    @media ${deviceMin.mobileS} {
      ${FONTS.font14}
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font16}
    }
  }

  span {
    ${FONT_FAMILY.FontSemiBold}
    color: ${COLORS.black};

    @media ${deviceMin.mobileS} {
      ${FONTS.font14}
      margin-top: 16px;
    }

    @media ${deviceMin.tablet} {
      ${FONTS.font14}
      margin-top: 0;
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font16}
    }
  }
`;
